/**
 * Configuration for the Front Chat feature
 */
export const FRONT_CHAT_CONFIG = {
  // Front Chat application ID
  chatId: (import.meta.env.VITE_FRONT_CHAT_ID as string) || 'ee1815dea718524ed6bebe059556b58b',

  // Initialization settings
  initDelay: 3000, // milliseconds to wait before initializing
  maxRetryAttempts: 3,
  retryDelay: 1000, // milliseconds between retry attempts

  // Routes where the launcher should be hidden
  // Supports React Router path patterns (e.g., '/note/:noteId', '/admin/*')
  hiddenRoutes: ['/admin/*', '/admin-v2/*', '/templates/*', '/templatebuilder'],

  // Environments where chat should not initialize
  disabledEnvironments: ['devv'], // TODO: remove or add correct environment

  // API endpoints
  apiEndpoints: {
    getChatBotHash: '/user/getChatBotHash',
  },

  // UI Configuration
  launcher: {
    position: {
      bottom: 3, // theme.spacing units
      x: 3, // Horizontal offset from left or right edge (theme.spacing units)
    },
    animation: {
      duration: 'short', // theme.transitions.duration
      hoverScale: 1.05,
    },
  },
} as const;
